import {createUseStyles} from 'react-jss';

const animateElement = {
  position: 'relative',
  overflow: 'hidden',
  
  '&:after': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(85deg, #f2f2f2, #fafafa, #f2f2f2)',
    animation: '$loading 1.5s infinite',
  },
};

const useStyles = createUseStyles({
  productList: {
    width: '100%',
    marginTop: 8,
    padding: [12, 8, 15],
    display: 'flex',
  },
  image: {
    height: 78,
    width: 78,
    minHeight: 78,
    minWidth: 78,
    background: '#f2f2f2',
    ...animateElement,
  },
  productDescription: {
    width: '100%',
    paddingLeft: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  deliveryContainer: {
    width: '100%',
    marginTop: 8,
    padding: [12, 8],
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
  },
  orderTotal: {
    padding: [17, 8],
  },
  ghostTitle: {
    height: '24px',
    background: '#f2f2f2',
    width: '100%',
    ...animateElement,
  },
  ghostText: {
    height: '18px',
    background: '#f2f2f2',
    width: '100%',
    position: 'relative',
    ...animateElement,
  },
  
  // Animations
  '@keyframes loading': {
    '0%': {
      left: '-100%',
    },
    '100%': {
      left: '100%',
    },
  },
});

export default function SkeletonOrderSummary() {
  const classes = useStyles();
  
  return (
    <>
      <div className={classes.ghostTitle} />
      <div className={classes.productList}>
        <img className={classes.image} alt="" src="" />
        <div className={classes.productDescription}>
          <span className={classes.ghostText} />
          <span className={classes.ghostText} />
          <span className={classes.ghostText} />
        </div>
      </div>
      <div className={classes.deliveryContainer}>
        <div className={classes.ghostTitle} />
      </div>
      <div className={classes.orderTotal}>
        <div className={classes.ghostTitle} />
      </div>
    </>
  );
}
